<script>
import options from './SpotCard.options'
export default options
</script>

<template>
  <article class="kb-spot-card" :class="spotCardData.colorTheme">
    <!-- v-if is to make sure decoration is shown if icon not active - icon and decoration cannot exit simultanously -->
    <template v-if="!spotCardData.svgIcon">
      <div class="kb-spot-card__box__decoration">
        <svg
          width=""
          height=""
          viewBox="0 0 946 257"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          role="presentation"
        >
          <path
            d="M-698.154 720.628C-614.642 775.767 -501.149 766.579 -427.628 693.059L103.706 162.567C312.897 -46.6238 652.06 -46.6238 861.245 162.567C1070.44 371.759 1070.44 710.921 861.245 920.107C652.054 1129.3 312.892 1129.3 103.706 920.107"
            stroke="white"
            stroke-width="130.892"
            stroke-miterlimit="10"
          />
          <path
            d="M-958.538 919.683C-1167.73 710.492 -1167.73 371.329 -958.538 162.143C-749.347 -47.0478 -410.184 -47.0478 -200.999 162.143L330.335 693.478C414.361 777.504 550.59 777.504 634.616 693.478C718.642 609.452 718.642 473.223 634.616 389.197C550.59 305.171 414.361 305.171 330.335 389.197L-200.999 919.688C-250.109 968.799 -306.376 1006.38 -366.449 1032.43"
            stroke="white"
            stroke-width="130.892"
            stroke-miterlimit="10"
          />
        </svg>
      </div>
    </template>

    <div class="kb-spot-card__box__content-container">
      <template v-if="spotCardData.svgIcon">
        <div class="kb-spot-card__box__icon-wrapper">
          <div
            class="kb-spot-card__box__circle"
            v-html="spotCardData.svgIcon"
          ></div>
        </div>
      </template>

      <div class="kb-spot-card__box__content">
        <h3 class="kb-spot-card__box__title">{{ spotCardData.title }}</h3>
        <p class="kb-spot-card__box__paragraph">{{ spotCardData.text }}</p>
        <div class="kb-spot-card__box__button-wrapper">
          <template
            v-for="(button, index) in spotCardData.buttons"
            :key="index"
          >
            <a
              :href="button.href"
              :target="button.target"
              class="kb-button kb-button--spot-border-color"
            >
              {{ button.text }}
              <div
                class="kb-button__icon-wrapper"
                v-html="button.svgIcon"
              ></div>
            </a>
          </template>
        </div>
      </div>
    </div>
  </article>
</template>
